"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableRowStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../../style/commons/_colors");
exports.useTableRowStyles = (0, core_1.makeStyles)(function () { return ({
    containerRows: {
        marginTop: 1,
        backgroundColor: _colors_1.rowBackground,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
            backgroundColor: _colors_1.secondaryHover,
        },
    },
    disabled: {
        '&:hover': {
            backgroundColor: _colors_1.secondaryHover,
        },
    },
    row: {
        height: 56,
        alignItems: 'center',
        display: 'flex',
    },
    expandedRow: {
        height: 56,
        backgroundColor: _colors_1.rowBackground,
        borderRadius: '4px',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        '&:hover': {
            backgroundColor: _colors_1.secondaryHover,
        },
    },
    fieldContainer: {
        overflow: 'hidden',
    },
    field: {
        padding: 8,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    draggableField: {
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
    },
    draggableIndicator: {
        width: 16,
        marginTop: 3,
        height: 16,
    },
    editableField: {
        padding: 8,
        display: 'flex',
        flexGrow: 1,
    },
    errorRow: {
        height: 72,
        display: 'flex',
        alignItems: 'flex-start',
    },
    actions: {
        marginLeft: 'auto',
        paddingRight: 16,
        alignSelf: 'center',
        minHeight: 10,
        minWidth: 45,
        height: '100%',
        marginTop: 25,
    },
    checkbox: {
        margin: 0,
    },
    checkboxContainer: {
        alignSelf: 'center',
    },
    selectFieldContainer: {
        padding: 8,
        fontWeight: 'normal',
        fontSize: 16,
    },
    draggableContainer: {
        alignSelf: 'center',
    },
}); });
